export default __webpack_public_path__ + "alberta-chat.30a7bf1a1d7f6f0c3a1f.svg";